import React from "react";

const AppML_ASP = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML ASP</h1>
      <p>This is the AppML ASP page content.</p>
    </div>
  );
};

export default AppML_ASP;
